import { compareDecimal, money, percentOf, type Money,
  sharePercent,
} from "@/shared/money/money";

export function CapitalUsed({
  used,
  limit,
  slotId,
}: {
  readonly used: Money;
  readonly limit: Money | null;
  readonly slotId: string;
}): React.JSX.Element {
  const unavailable = limit === null || compareDecimal(limit, "0") <= 0;

  if (unavailable) {
    return (
      <section data-testid={`capital-used-${slotId}`} className="min-w-0">
        <div className="mb-2 flex items-baseline justify-between gap-3">
          <span className="text-label-caps tracking-[0.08em] text-text-muted">Capital Used</span>
          <span className="font-mono text-helper-sm text-text-muted">—</span>
        </div>
        <div className="h-1.5 rounded-full bg-surface-selected" />
      </section>
    );
  }

  const share = percentOf(used, limit);

  return (
    <section data-testid={`capital-used-${slotId}`} className="min-w-0">
      <div className="mb-2 flex items-baseline justify-between gap-3">
        <span className="text-label-caps tracking-[0.08em] text-text-muted">Capital Used</span>
        <span className="font-mono text-helper-sm tabular-nums text-text-secondary">
          {money(used)} / {money(limit)} USDT · {sharePercent(share)}
        </span>
      </div>
      <div
        role="progressbar"
        aria-label="Использованный капитал цикла"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={share as unknown as number}
        aria-valuetext={sharePercent(share)}
        className="h-1.5 overflow-hidden rounded-full bg-surface-selected"
      >
        <span
          aria-hidden="true"
          className="block h-full rounded-full bg-action-primary transition-[width] duration-200 motion-reduce:transition-none"
          style={{ width: `${share}%` }}
        />
      </div>
    </section>
  );
}
